import { CONTEST_WINDOW_DURATION_OPTIONS } from '../data/contestWindowDurationOptions';

export default function parseContestWindowOptions(contestWindow, windowValue) {
  const value = windowValue ? windowValue : contestWindow;
  const window = CONTEST_WINDOW_DURATION_OPTIONS?.find(
    (obj) => obj.value === value
  );

  if (window) {
    return window;
  } else if (value) {
    return { value, label: value + ' Mins' };
  } else return null;
}
